'use strict';

/**
 * DonationEquipmentDirectCheckout
 *
 * When the sticky bar is not present on the page (show_sticky_bar is disabled),
 * clicking "Donate" on an individual equipment item directly sends an AJAX
 * request to add_campaign_to_cart and redirects to checkout.
 *
 * Data required by the AJAX request is always rendered server-side in a hidden
 * .donation_equipment_cart_data element, regardless of sticky bar visibility.
 */
export default function DonationEquipmentDirectCheckout() {
	if ( document.querySelector( '.donation_equipment_sticky_bar' ) ) {
		return;
	}

	const cartData = document.querySelector( '.donation_equipment_cart_data' );
	if ( ! cartData ) {
		return;
	}

	const adminAjax  = cartData.dataset.adminAjax;
	const campaignId = cartData.dataset.campaignId;
	const nonce      = cartData.dataset.nonce;

	if ( ! adminAjax || ! campaignId || ! nonce ) {
		return;
	}

	const checkboxes = document.querySelectorAll(
		'article.levcharity_form__products_item.donation_equipment_product .levcharity_donation_equipment_checkbox'
	);

	checkboxes.forEach( checkbox => {
		checkbox.addEventListener( 'change', () => {
			if ( ! checkbox.checked ) {
				return;
			}

			const productEl = checkbox.closest( '.donation_equipment_product' );
			const productId = productEl?.dataset.id;
			if ( ! productId ) {
				return;
			}

			const currencyInput = document.querySelector( 'input[name="equipment_paying_currency"]' );
			const currency = currencyInput?.value || cartData.dataset.currency;

			const formData = new FormData();
			formData.append( 'action',                    'add_campaign_to_cart' );
			formData.append( 'product_ids',               productId );
			formData.append( 'campaign_id',               campaignId );
			formData.append( 'nonce',                     nonce );
			formData.append( 'equipment_paying_currency', currency );
			formData.append( 'user_paying_currency',      currency );

			document.body.classList.add( 'ajax-loading' );

			fetch( adminAjax, { method: 'POST', body: formData } )
				.then( r => r.json() )
				.then( data => {
					if ( data.local_cart ) {
						localStorage.setItem( 'cart', JSON.stringify( data.local_cart ) );
					}
					if ( data.redirect_url ) {
						window.location.href = data.redirect_url;
					} else {
						window.location.reload();
					}
				} )
				.catch( err => console.error( 'Equipment direct-to-cart error:', err ) )
				.finally( () => document.body.classList.remove( 'ajax-loading' ) );
		} );
	} );
}
